import { BrowserRouter, Route, Outlet, Routes } from 'react-router-dom';
import { Layout } from './components/layout';
import { Protected } from './components/protected';
import Error404Page from './pages/404';
import ForgotPasswordPage from './pages/forgot-password';
import HomePage from './pages/home';
import LabResultsCreatePage from './pages/lab-results/create';
import LabResultsDetailPage from './pages/lab-results/detail';
import LabResultsIndexPage from './pages/lab-results';
import LoginPage from './pages/login';
import ResetPasswordPage from './pages/reset-password';
import SuccessResetPasswordPage from './pages/success-reset-password';
import OrdersListPage from './pages/orders';
import OrderDetailPage from './pages/orders/details';
import GiftsListPage from './pages/gifts';
import GiftDetailPage from './pages/gifts/details';
import EventsListPage from './pages/events';
import EventEditPage from './pages/events/edit';
import EventDetailPage from './pages/events/detail';
import { SplashImage } from './components/splash-image';
import { AuthLayout } from './components/auth-layout';
import CustomersListPage from './pages/customers';
import CustomerDetailPage from './pages/customers/detail';
import EditCustomerPage from './pages/customers/edit';
import ReportsListPage from './pages/reports';
import SettingsPage from './pages/settings';
import ComponentsPage from './pages/components';
import AccountVerifyPage from './pages/AccountVerify';
import LabResultVerbiages from './pages/lab-result-verbiages';
import ChangePasswordForm from './components/auth/change-password-form';
import KitsListPage from './pages/kits';

function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<Error404Page />} />
        <Route
          path="/"
          element={
            <Layout>
              <Outlet />
            </Layout>
          }>
          <Route
            path="/"
            element={
              <Protected>
                <Outlet />
              </Protected>
            }>
            <Route path="/" element={<HomePage />} />
            <Route path="/components" element={<ComponentsPage />} />

            <Route path="/orders">
              <Route path="/orders" element={<OrdersListPage />} />
              <Route path="/orders/:id" element={<OrderDetailPage />} />
            </Route>
            <Route path="/gifts">
              <Route path="/gifts" element={<GiftsListPage />} />
              <Route path="/gifts/:id" element={<GiftDetailPage />} />
            </Route>
            <Route path="/kits">
              <Route path="/kits" element={<KitsListPage />} />
            </Route>
            <Route path="/events">
              <Route path="/events" element={<EventsListPage />} />
              <Route path="/events/:id" element={<EventDetailPage />} />
              <Route path="/events/new" element={<EventEditPage />} />
              <Route path="/events/:id/edit" element={<EventEditPage />} />
            </Route>

            <Route path="/customers">
              <Route path="/customers" element={<CustomersListPage />} />
              <Route path="/customers/:id" element={<CustomerDetailPage />} />
              <Route
                path="/customers/:id/edit"
                element={<EditCustomerPage />}
              />
            </Route>
            <Route path="/reports">
              <Route path="/reports" element={<ReportsListPage />} />
            </Route>
            <Route path="/settings">
              <Route path="/settings" element={<SettingsPage />} />
            </Route>
            <Route
              path="/lab-result-verbiages"
              element={<LabResultVerbiages />}
            />
            <Route path="/lab-results">
              <Route path="/lab-results" element={<LabResultsIndexPage />} />
              <Route
                path="/lab-results/:id"
                element={<LabResultsDetailPage />}
              />
              <Route
                path="/lab-results/create"
                element={<LabResultsCreatePage />}
              />
            </Route>
          </Route>
        </Route>
        <Route
          path="/auth"
          element={
            <AuthLayout
              bannerContent={<SplashImage src="/landing-splash.jpeg" />}>
              <Outlet />
            </AuthLayout>
          }>
          <Route path="/auth/login" element={<LoginPage />} />
          <Route path="/auth/verify" element={<AccountVerifyPage />} />
          <Route
            path="/auth/forgot-password"
            element={<ForgotPasswordPage />}
          />
          <Route path="/auth/reset-password" element={<ResetPasswordPage />} />
          <Route
            path="/auth/change-password"
            element={<ChangePasswordForm />}
          />
          <Route
            path="/auth/reset-password-success"
            element={<SuccessResetPasswordPage />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default Router;
